import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../context/AuthContext";
import axios from "axios";
import Loader from "../../../components/Loader";
import { Link } from "react-router-dom";
import { PolyColumn } from "../../../components/headerContent";
import { useQuery } from "@tanstack/react-query";
import Table from "../../../components/Table";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import NumberCard from "../../../components/Card/NumberCard";
import { useTranslation } from "react-i18next";

export default function EquipementPoly() {
    const { user, apiUrl } = useContext(AuthContext)
    const { t } = useTranslation();

    const getPolyDevice = async () => {
        const res = await axios(`${apiUrl}poly`, {
            method: "get",
            withCredentials: true
        })

        return res.data
    }

    const { data: polyDeviceData, isLoading, isError } = useQuery({
        queryKey: ["polycom"],
        queryFn: getPolyDevice
    });

    if (isLoading) {
        return <Loader />;
    }

    if (isError) {
        return (
            <div className="ecp-container">
                <div className="ecp-container-content-error">
                    <div className="error-container">
                        <img src='../assets/ecp_error.svg' alt="icône d'erreur" />
                        <div className="error-container-text">
                            <h1 className="page-title">
                                {t("Aucun équipement disponible")}
                            </h1>
                            <p className="page-link_home">
                                <Link to="/"> {t("Revenir à l'accueil")}</Link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const polyDeviceNodes = polyDeviceData.map(item => item.node);

    return (
        <div className="ecp-container">
            <div className="ecp-container-content">
                <div className="ecp-container-content-header">
                    <div className="ecp-container-content-header-title">
                        <h1 className="page-title page-logo">
                            <img src="../assets/poly_logo.png" alt="Logo de Cisco Webex" />
                            <h1 className="page-title">{t("Equipements")}  Poly</h1>
                        </h1>
                    </div>
                </div>
                <section className="page-section">
                    <NumberCard title={t("Nombre d'équipements disponibles")}
                        number={polyDeviceNodes.length}
                        logo={faCircleCheck}
                        color={"#AEC353"}
                        stylesIcons={"logo-certificats"}
                    />
                </section>
                <div className='cato-content-table'>
                    <Table
                        tableColumns={PolyColumn}
                        tableData={polyDeviceNodes}
                    />
                </div>
            </div>
        </div>

    )
}